import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../CreateIconComponent';

export type TruckIconCircleProps = CreateIconComponentProps & {
  title?: string;
  viewBox?: string;
};

export const TruckIcon = ({
  title = 'Truck',
  viewBox = '0 0 24 24',
  ...props
}: CreateIconComponentProps): JSX.Element => (
  <CreateIconComponent title={title} viewBox={viewBox} {...props}>
    <g fill="none">
      <circle
        cx="7"
        cy="17"
        r="2"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="17"
        cy="17"
        r="2"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 17.8C5.44183 17.8 5.8 17.4418 5.8 17C5.8 16.5582 5.44183 16.2 5 16.2V17.8ZM3 17H2.2C2.2 17.4418 2.55817 17.8 3 17.8V17ZM13 5H13.8C13.8 4.55817 13.4418 4.2 13 4.2V5ZM12.2 17C12.2 17.4418 12.5582 17.8 13 17.8C13.4418 17.8 13.8 17.4418 13.8 17H12.2ZM9 16.2C8.55817 16.2 8.2 16.5582 8.2 17C8.2 17.4418 8.55817 17.8 9 17.8V16.2ZM15 17.8C15.4418 17.8 15.8 17.4418 15.8 17C15.8 16.5582 15.4418 16.2 15 16.2V17.8ZM19 16.2C18.5582 16.2 18.2 16.5582 18.2 17C18.2 17.4418 18.5582 17.8 19 17.8V16.2ZM21 17V17.8C21.4418 17.8 21.8 17.4418 21.8 17H21ZM21 11H21.8C21.8 10.5582 21.4418 10.2 21 10.2V11ZM13 10.2C12.5582 10.2 12.2 10.5582 12.2 11C12.2 11.4418 12.5582 11.8 13 11.8V10.2ZM13 5.2C12.5582 5.2 12.2 5.55817 12.2 6C12.2 6.44183 12.5582 6.8 13 6.8V5.2ZM18 6L18.686 5.5884C18.5414 5.34744 18.281 5.2 18 5.2V6ZM20.314 11.4116C20.5413 11.7905 21.0327 11.9133 21.4116 11.686C21.7905 11.4587 21.9133 10.9673 21.686 10.5884L20.314 11.4116ZM5 16.2H3V17.8H5V16.2ZM3.8 17V6H2.2V17H3.8ZM3.8 6C3.8 5.88954 3.88954 5.8 4 5.8V4.2C3.00589 4.2 2.2 5.00589 2.2 6H3.8ZM4 5.8H13V4.2H4V5.8ZM12.2 5V17H13.8V5H12.2ZM9 17.8H15V16.2H9V17.8ZM19 17.8H21V16.2H19V17.8ZM21.8 17V11H20.2V17H21.8ZM21 10.2H13V11.8H21V10.2ZM13 6.8H18V5.2H13V6.8ZM17.314 6.4116L20.314 11.4116L21.686 10.5884L18.686 5.5884L17.314 6.4116Z"
        fill="currentColor"
      />
    </g>
  </CreateIconComponent>
);

export default TruckIcon;
